module.exports = __webpack_public_path__ + "static/nyoutritious-5-9ac2d4b87feafe4bd026df0d604791da.png";